import React from "react";
import insta from '../../assets/photos/insta.png'
import google from '../../assets/photos/google.png'


const Reviews2 = () => {


    return (
        <>
            <div className="home-reviews2">

                <div className="CTA-wrapper">
                    <div className="review2-h2">See what else our customers are saying.</div>
                    <div className="google-insta-links">
                        <a target="_blank" href="https://www.google.com/search?q=lennon+window+cleaning&safe=images&sca_esv=8e23599b05dcda53&hl=en&sxsrf=AE3TifNuYW1oY1YvPGtYqn3qMwdhLDjnng%3A1756146842237&ei=mqysaKicDsKr0PEPs57Z4AE&ved=0ahUKEwio0dHlzKaPAxXCFTQIHTNPFhwQ4dUDCBA&uact=5&oq=lennon+window+cleaning&gs_lp=Egxnd3Mtd2l6LXNlcnAiFmxlbm5vbiB3aW5kb3cgY2xlYW5pbmcyBBAjGCcyDhAuGIAEGMcBGI4FGK8BMgUQABiABDIGEAAYFhgeMgIQJjILEAAYgAQYhgMYigUyCxAAGIAEGIYDGIoFMgsQABiABBiGAxiKBTIIEAAYogQYiQUyCBAAGIAEGKIESJ4cUO8PWMAZcAJ4AJABAJgBsQGgAeoIqgEDMC45uAEDyAEA-AEBmAIKoALbB8ICDhAAGIAEGLADGIYDGIoFwgIIEAAYsAMY7wXCAgsQABiABBiwAxiiBMICCxAAGLADGKIEGIkFwgIFEAAY7wWYAwCIBgGQBgmSBwMyLjigB7I_sgcDMC44uAfWB8IHBTAuNi40yAcd&sclient=gws-wiz-serp#lrd=0x68831600bba56705:0x41d13b74774dfa34,1,,,," className="social-circle"><img className='google-icon' alt="google icon" src={google} /></a>
                        <a target="_blank" href="https://www.instagram.com/lennonwindowcleaning/" className="social-circle"><img className='insta-icon' alt="instagram icon" src={insta} /></a>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Reviews2